import fr from './fr.json';
import en from './en.json';

export const translations = {
  fr,
  en
};

export const defaultLanguage = 'fr';

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' }
];

export const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};
